module.exports = __webpack_public_path__ + "img/footer-code.4657c233.jpg";